<script>
import { mapGetters } from 'vuex'

export default {
  name: 'TheFooter',
  data () {
    return {
      ovbLogo: require('@/assets/img/ovb_logo_text_only.svg')
    }
  },
  computed: {
    ...mapGetters({
      isBrainRehabPromo: 'brochure/isBrainRehab'
    }),
    emailHelp () {
      return 'help@ourvisualbrain.com'
    },
    currentYear () {
      return this.$dateFns.getYear(new Date())
    }
  }
}
</script>

<template>
  <footer
    class="ovb-footer"
  >
    <div class="ovb-footer-content">
      <div class="content-row container mobile-container">
        <div>
          <img
            class="ovb-text-logo"
            alt="Our Visual Brain"
            :src="ovbLogo"
          />
          <div class="my-2">
            <router-link
                class="footer-link"
                :to="{ name: 'ContactView' }"
            >Contact Us</router-link>
          </div>
          <div class="my-2">
            <router-link
                class="footer-link"
                :to="{ name: 'HelpView' }"
            >Need Help?</router-link>
          </div>
<!--          <div-->
<!--            class="my-2"-->
<!--          >-->
<!--            Email:  <a-->
<!--            href="mailto:help@ourvisualbrain.com"-->
<!--            class="footer-link"-->
<!--          >-->
<!--            help@ourvisualbrain.com-->
<!--          </a>-->
<!--          </div>-->
          <div>
            Phone: <a href="tel:+18004091924">+1 800-409-1924</a>
          </div>
        </div>
        <div
          class="nav-list"
        >
          <div
            class="nav-title"
          >
            Resources
          </div>
          <template v-if="!isBrainRehabPromo">
            <a
              href="https://ourvisualbrain.hflip.co/bea2844c1f.html"
              target="_blank"
              class="footer-link"
            >
              <span class="icon is-medium mr-1"><i class="mdi mdi-book-open-variant"></i></span>OVB User's Guide
            </a>
            <a
                href="https://ourvisualbrain.hflip.co/4e5df4c1d3.html"
                target="_blank"
                class="footer-link"
            >
              <span class="icon is-medium mr-1"><i class="mdi mdi-book-open-variant"></i></span>OVB Prospective Clinic Information Packet
            </a>
            <a
              href="/pdf/ENG/The OVB Reading Framework.pdf"
              target="_blank"
              class="footer-link"
            >
              <span class="icon is-medium mr-1"><i class="mdi mdi-file-pdf-box"></i></span>The OVB Reading Framework
            </a>
            <a
                href="/pdf/ENG/OVB Sports Vision Framework.pdf"
                target="_blank"
                class="footer-link"
            >
              <span class="icon is-medium mr-1"><i class="mdi mdi-file-pdf-box"></i></span>OVB Sports Vision Framework
            </a>
            <a
              href="/pdf/ENG/OVB Parent Companion Guide.pdf"
              target="_blank"
              class="footer-link"
            >
              <span class="icon is-medium mr-1"><i class="mdi mdi-file-pdf-box"></i></span>OVB Parent Companion Guide
            </a>
            <a
              href="/pdf/ENG/OVB Adult Companion Guide.pdf"
              target="_blank"
              class="footer-link"
            >
              <span class="icon is-medium mr-1"><i class="mdi mdi-file-pdf-box"></i></span>OVB Adult Companion Guide
            </a>
            <a
              href="/pdf/ENG/OVB Compliance Guide.pdf"
              target="_blank"
              class="footer-link"
            >
              <span class="icon is-medium mr-1"><i class="mdi mdi-file-pdf-box"></i></span>OVB Compliance Guide
            </a>
            <a
              href="/pdf/ENG/OVB Calibration Instructions.pdf"
              target="_blank"
              class="footer-link"
            >
              <span class="icon is-medium mr-1"><i class="mdi mdi-file-pdf-box"></i></span>OVB Calibration Instructions
            </a>
          </template>
          <template v-else></template>
        </div>
        <div
          class="nav-list"
        >
          <div
            class="nav-title"
          >
            About
          </div>
          <router-link
            class="footer-link"
            :to="{ name: 'FaqView', params: {stickyNav: true}}"
          >Frequently Asked Questions (FAQ)</router-link>
          <router-link
            class="footer-link"
            :to="{ name: 'PrivacyPolicy', params: {stickyNav: true}}"
          >Privacy Policy</router-link>
          <router-link
            class="footer-link"
            :to="{ name: 'TermsAndConditions', params: {stickyNav: true}}"
          >Terms and Conditions</router-link>
        </div>
      </div>
      <div class="footer-separator mt-6" />
      <div class="content-row container">
        <div
          class="copyright-notice"
        >
          <p>
            Copyright © {{ currentYear }} Our Visual Brain LLC. All rights reserved.
          </p>
          <p class="mt-1">
            The information and graphics on this Web Site may not be reproduced in any material form or transmitted to any persons without permission from Our Visual Brain.
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>

<style scoped lang="scss">
footer.ovb-footer {
  background-color: $jet;
  padding: 2rem 0 2rem 0;
  display: flex;
  flex-direction: column;
  color: $gray-light;
  position: relative;
  @include fullhd {
    padding: 2rem 0 3rem 0;
  }
}
.ovb-text-logo {
  width: 15rem;
  opacity: .5;
}
.ovb-footer-content {
  background-color: $jet;
  flex: 1;
  .footer-separator {
    border-top: 0.5px solid $gray-light;
    opacity: 0.25;
  }
  .content-row {
    padding: 0 1rem;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: space-between;
    @include tablet {
      flex-direction: row;
    }
    @include desktop {
      padding: 0;
    }
  }
  .footer-link {
    color: $gray-light;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
  .nav-list {
    display: flex;
    flex-direction: column;
    .nav-title {
      font-family: $family-semibold;
      font-size: 1.25rem;
      opacity: 0.5;
    }
  }
  .copyright-notice {
    font-size: 0.85rem;
    opacity: 0.5;
    @include mobile {
      padding-bottom: 2rem;
    }
  }
}
</style>
